// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Router from 'vue-router'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import Vuex from 'vuex'
import axios from 'axios'

// 样式文件
import '@styles/index.scss'
import '@styles/element-custom.scss';
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

// 需要全局调用的脚本引入
import '@/permission'
import '@utils/routerUtil'
import '@/assets/svg'
import consts from '@/utils/bizConstant'

import VueQuillEditor from 'vue-quill-editor'

import Vant from 'vant'
import 'vant/lib/index.css';

Vue.prototype.$http = axios;
Vue.prototype.$consts = consts;
Vue.config.productionTip = false;

Vue.use(VueQuillEditor, /* { default global options } */)

// component
Vue.use(ElementUI);
Vue.use(Vuex);
Vue.use(Vant)

// 解决重复点击相同菜单，路由报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {})
}

/* eslint-disable no-new */
var vue = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

export default vue



// WEBPACK FOOTER //
// ./src/main.js